export type CurrencySymbol = keyof typeof currencySymbols;

export const currencySymbols = {
  percent: "%",
  AED: String.fromCharCode(0x62f, 0x2e, 0x625),
  AUD: "A$",
  BRL: "R$",
  GBP: "£",
  CAD: "C$",
  CHF: String.fromCharCode(8355),
  CLP: "CLP$",
  DKK: "kr.",
  EUR: "€",
  HKD: "HK$",
  INR: "₹",
  JPY: "¥",
  MXN: "₱",
  NZD: "NZ$",
  SEK: "kr",
  SGD: "S$",
  SKW: "₩",
  USD: "$",
  ZAR: "R",
};
